var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconEyeWhite(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "xv9fpbcm2a",
    d: "M12 4c5.162 0 9.531 3.393 11 8.07-1.469 4.676-5.838 8.07-11 8.07s-9.531-3.394-11-8.07C2.469 7.393 6.838 4 12 4zm0 3.458c-2.547 0-4.611 2.065-4.611 4.612 0 2.546 2.064 4.61 4.611 4.61 2.547 0 4.611-2.064 4.611-4.61 0-2.547-2.064-4.612-4.611-4.612zm0 2.306c1.273 0 2.306 1.032 2.306 2.306 0 1.273-1.033 2.305-2.306 2.305-1.273 0-2.306-1.032-2.306-2.305 0-1.274 1.033-2.306 2.306-2.306z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    fill: "#ffffff",
    fillRule: "nonzero",
    xlinkHref: "#xv9fpbcm2a"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEyeWhite);
export default __webpack_public_path__ + "static/media/icon-eye-white.4d8b8769a1d117730d6b4e9d59970271.svg";
export { ForwardRef as ReactComponent };